import * as React from "react";

import "bulma/css/bulma.css";
import {Redirect, Route, RouteProps, Router, Switch} from "react-router-dom";
import Dashboard from "../src/routes/Dashboard";
import Login from "../src/routes/Login/NewLogin";
import Privacy from "../src/routes/PrivacyPolicy";
import history from "./utils/history";
import ScrollToTop from "./utils/ScrollToTop";
import {getUserData, isLoggedIn} from "./utils/auth";
import Settings from "./routes/Settings";
import {userContext} from "./utils/userContext";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.min.css';
import APIKeys from "./routes/APIKeys";
import PageNotFound from "./routes/ErrorPage/PageNotFound";
import RequestModel from "./routes/RequestModel";
import ContactUsForm from "./components/Contact";
import Registered from "./routes/Login/Registered";

interface IPrivateRouteProps extends RouteProps {
    component: React.ComponentClass;
}

const PrivateRoute = ({
                          component: Component,
                          ...rest
                      }: IPrivateRouteProps) => (
    <Route
        {...rest}
        render={props => isLoggedIn() ? <Component {...props} /> : <Redirect to="/login"/>}
    />
);

interface IAppState {
    user: any;
    showContactForm: boolean;
}

class App extends React.Component<{}, IAppState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            user: {},
            showContactForm: false
        };
    }

    public onUpdateUserContext(user: any) {
        this.setState({
            user
        });
    }

    public openContactForm(user: any) {
        this.setState({
            showContactForm: true
        });
    }

    public componentDidMount() {
        // if user state is empty reload user data
        if (Object.getOwnPropertyNames(this.state.user).length === 0) {
            getUserData().then((user) => {
                this.setState({
                    user
                });
            }).catch(() => {
                /* tslint:disable:no-empty */
            });
        }
    }

    public render() {
        return (
            <div>
                <Router history={history}>
                    <userContext.Provider value={this.state.user}>
                        <ScrollToTop>
                            <Switch>
                                <Route
                                    exact={true}
                                    path="/"
                                    render={() => <Redirect to="/models/hedging"/>}
                                />
                                <Route
                                    exact={true}
                                    path="/models"
                                    render={() => <Redirect to="/models/hedging"/>}
                                />
                                <Route
                                    exact={true}
                                    path="/privacy"
                                    render={() => isLoggedIn() ? <Privacy openContactForm={this.openContactForm.bind(this)}/> : <Redirect to="/login"/>}
                                />
                                <Route
                                    exact={true}
                                    path="/models/*"
                                    render={(props) => isLoggedIn() ? <Dashboard
                                        {...props}
                                        openContactForm={this.openContactForm.bind(this)}
                                    /> : <Redirect to="/login"/>}
                                />
                                <Route
                                    exact={true}
                                    path="/settings"
                                    render={() => isLoggedIn() ? <Settings
                                        onUpdateUserContext={this.onUpdateUserContext.bind(this)}
                                        openContactForm={this.openContactForm.bind(this)}
                                    /> : <Redirect to="/login"/>}
                                />
                                <Route
                                    exact={true}
                                    path="/request-model"
                                    render={() => isLoggedIn() ? <RequestModel openContactForm={this.openContactForm.bind(this)}/> : <Redirect to="/login"/>}
                                />
                                <PrivateRoute exact={true} path="/api-keys" component={APIKeys}/>
                                <Route
                                    exact={true}
                                    path="/login"
                                    render={() => <Login onUpdateUserContext={this.onUpdateUserContext.bind(this)}/>}
                                />
                                <Route
                                    exact={true}
                                    path="/signup"
                                    render={() => <Login activeTab="signup" onUpdateUserContext={this.onUpdateUserContext.bind(this)}/>}
                                />
                                <Route
                                    exact={true}
                                    path="/thankyou"
                                    render={() => <Registered/>}
                                />
                                <Route
                                    path="/*"
                                    component={PageNotFound}
                                />
                            </Switch>
                        </ScrollToTop>
                    </userContext.Provider>
                </Router>
                <ToastContainer
                    position="bottom-right"
                    hideProgressBar={true}
                    draggable={false}
                    newestOnTop={true}
                    pauseOnHover={true}
                    pauseOnFocusLoss={true}
                    closeOnClick={false}
                    limit={5}
                    autoClose={7000}
                    style={{width: '340px'}}
                />
                {
                    this.state.showContactForm ? <ContactUsForm onClose={() => {
                        this.setState({showContactForm: false});
                    }}/> : <></>
                }
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx